<template>
  <div>
    <basic-container>
      <el-form :model="info" :rules="rules" ref="infoForm" label-width="120px">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>店铺信息:</span>
          </div>
          <el-row>
            <el-col :span="8"><strong>店铺名称:</strong> {{ info.shopName }}</el-col>
            <el-col :span="8"><strong>店铺电话:</strong> {{ info.shopMobile }}</el-col>
            <el-col :span="8"><strong>店铺地址:</strong> {{ info.shopAddress }}</el-col>
          </el-row>
        </el-card>
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目地址" prop="customAddress">
                <el-input v-model="info.customAddress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 客户信息 -->
              <el-form-item label="客户姓名" prop="customName">
                <el-input v-model="info.customName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户手机号" prop="customMobile">
                <el-input v-model="info.customMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="attachmentUrl" label="附件备注">
                <ImageUpload action="#" :multiple="true" :inTable="true" :limit="9" @uploaded="handleUploaded"
                  :uploaded-images="info.attachmentUrl" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 施工图纸 -->
          <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="施工图纸">
                <ImageUpload action="#" :multiple="true" :inTable="true" :limit="9" @uploaded="handleDrawingUrlUploaded"
                  :uploaded-images="info.drawingUrl"/>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="其他产品" prop="otherProducts">
                <el-select v-model="info.otherProducts" multiple placeholder="请选择" clearable>
                  <el-option v-for="item in otherProductsOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="锅炉主机品牌" prop="boilerBrand">
                <el-input v-model="info.boilerBrand"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="锅炉主机供应方式" prop="supplyMode">
                <el-select v-model="info.supplyMode" placeholder="请选择" clearable>
                  <el-option v-for="item in supplyModeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="浴室暖气片数量" prop="numberGroups">
                <el-input-number v-model="info.numberGroups" controls-position="right" :min="0"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="附加选项" prop="additionalOptions">
                <el-select v-model="info.additionalOptions" multiple placeholder="请选择" clearable>
                  <el-option v-for="item in additionalOptionsOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="info.remarks"></el-input>
          </el-form-item>
          <!-- 产品选择表格 -->
          <el-form-item label="产品列表" prop="selectedGoods">
            <el-table :data="selectedGoods" style="width: 100%" border>
              <el-table-column prop="goodsId" label="产品名称">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.goodsId" placeholder="请选择产品" :disabled="!isEditable(scope.row)"
                    filterable @change="handleGoodsChange(scope.row)">
                    <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name" :value="goods.id"
                      :disabled="isOptionDisabled(goods.id)"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <!-- 施工图纸上传 -->
              <el-table-column label="施工图纸" align="center" width="900">
                <template slot-scope="scope">
                  <ImageUpload action="#" :multiple="true" :inTable="true" :limit="9"
                    :uploaded-images="scope.row.drawingUrl"
                    @uploaded="(urls) => handleDrawingUrlUploaded(scope.row, urls)" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-minus" @click="removeGoods(scope.$index)"
                    :disabled="!isEditable(scope.row)">删除产品</el-button>
                  <el-button type="text" icon="el-icon-plus" @click="addGoods"
                    style="margin-top: 10px;">添加产品</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="text" icon="el-icon-plus" @click="addGoods"
              v-if="selectedGoods.length === 0">添加产品</el-button>
          </el-form-item>
        </el-card>
      </el-form>

      <!-- 提交和返回按钮 -->
      <div style="width: 100%; display: flex; justify-content: center; margin-top: 20px;">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        <el-button type="primary" size="small" @click="submit" icon="el-icon-circle-check-outline">确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { getMerchantOrder, editMerchantOrder } from "@/api/work/waterProject/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ImageUpload from "./components/videoAndFileUpload/videoAndFileUpload.vue";
export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      goodsList: [], // 产品列表
      selectedGoods: [], // 用户选择的产品
      otherProductsOptions: [
        {
          value: "蘑菇板湿法日丰地暖",
          label: "蘑菇板湿法日丰地暖"
        },
        {
          value: "铝板干法日丰地暖",
          label: "铝板干法日丰地暖"
        },
        {
          value: "电地暖：合金丝发热线",
          label: "电地暖：合金丝发热线"
        },
        {
          value: "电地暖：发热膜",
          label: "电地暖：发热膜"
        },
        {
          value: "电地暖：碳纤维",
          label: "电地暖：碳纤维"
        },
        {
          value: "小管距地暖",
          label: "小管距地暖"
        },
        {
          value: "新风系统",
          label: "新风系统"
        },
        {
          value: "中央热水",
          label: "中央热水"
        },
        {
          value: "两联供",
          label: "两联供"
        },
        {
          value: "五恒系统",
          label: "五恒系统"
        }
      ],
      supplyModeOptions: [
        {
          value: "日丰地暖成都营销中心提供",
          label: "日丰地暖成都营销中心提供"
        },
        {
          value: "甲供乙安",
          label: "甲供乙安"
        },
        {
          value: "甲供甲安",
          label: "甲供甲安"
        }
      ],
      additionalOptionsOptions: [
        {
          value: "生活热水循环泵",
          label: "生活热水循环泵"
        },
        {
          value: "外置生活热水储水罐",
          label: "外置生活热水储水罐"
        }
      ],
      info: {
        contactName: "",
        contactMobile: "",
        customAddress: "",
        // installTime: null,
        // retailPrice: "",
        otherProducts: "",
        boilerBrand: "",
        supplyMode: "",
        numberGroups: "",
        additionalOptions: "",
        remarks: "",
        // otherRequirements: "",
      }, // 表单数据
      baseRules: {
        contactName: [{ required: true, message: "请输入报备人", trigger: "blur" }],
        contactMobile: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        customAddress: [{ required: true, message: "请输入项目地址", trigger: "blur" }],
      }
    };
  },
  computed: {
    rules() {
      const rules = { ...this.baseRules };
      return rules;
    }
  },
  created() {
    const id = this.$route.query.id;

    if (id) {
      getMerchantOrder(id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = data;
          this.info.attachmentUrl = data.attachmentUrl || [];  // 确保 attachmentUrl 存在并赋值
          this.info.otherProducts = data.otherProducts ? data.otherProducts.split(",") : [];
          this.info.supplyMode = data.supplyMode || "";
          this.info.additionalOptions = data.additionalOptions ? data.additionalOptions.split(",") : [];
          this.findPureWaterGoodsByRootDepartId(data.list);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  },
  methods: {
    handleUploaded(urls) {
      this.info.attachmentUrl = urls;
    },
    handleDrawingUrlUploaded(row, urls) {
      row.drawingUrl = urls;
    },
    // 处理安装时间变更
    handleInstallTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime();
        this.info.installTime = timestamp;
      } else {
        this.info.installTime = null;
      }
    },
    // 获取商品列表
    findPureWaterGoodsByRootDepartId(selectedGoods) {
      const type = 'ENGINEERING'
      findPureWaterGoodsByRootDepartId(type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
            this.selectedGoods = selectedGoods.map(item => ({
              goodsId: item.goodsId,
              serviceOrderId: item.serviceOrderId,
              id: item.id ? item.id : '',
              declarationId: item.declarationId,
              name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : "",
              drawingUrl: item.drawingUrl ? item.drawingUrl.split(",").map(url => ({ url })) : []
            }));

          } else {
            this.goodsList = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleGoodsChange(row) {
      // 根据选择的goodsId在goodsList中查找相应的产品
      const selectedGoods = this.goodsList.find(goods => goods.id === row.goodsId);
      if (selectedGoods) {
        // 更新row中的name和goodsId
        row.goodsId = selectedGoods.id;
        row.name = selectedGoods.name;
      } else {
        // 如果未找到匹配的产品，清空name
        row.goodsId = null;
        row.name = '';
      }
    },
    // 动态添加产品
    addGoods() {
      if (this.selectedGoods.length === this.goodsList.length) {
        this.$message({
          showClose: true,
          message: "所有产品都已经选择",
          type: "warning"
        });
        return;
      } else {
        this.selectedGoods.push({ goodsId: null });
      }
    },

    // 移除产品
    removeGoods(index) {
      this.selectedGoods.splice(index, 1);
    },

    // 返回上一步
    goBack() {
      let item = {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },

    // 判断产品是否可编辑
    isEditable(item) {
      return !item.serviceOrderId;
    },
    // 判断选项是否被禁用
    isOptionDisabled(goodsId) {
      return this.selectedGoods.some(item => item.goodsId === goodsId);
    },
    // 提交表单
    submit() {
      // 处理产品选择和施工图纸数据
      this.selectedGoods.forEach(product => {
        if (Array.isArray(product.drawingUrl)) {
          product.drawingUrl = product.drawingUrl.map(item => item.url).join(",");
        }
      });

      // 提交其他表单数据
      this.info.productName = this.selectedGoods.map((g) => `${g.name}`).join(",");
      this.info.productId = this.selectedGoods.map((g) => g.goodsId).join(",");
      if (Array.isArray(this.info.otherProducts)) {
      this.info.otherProducts = this.info.otherProducts.join(",");
      }
      if (Array.isArray(this.info.additionalOptions)) {
      this.info.additionalOptions = this.info.additionalOptions.join(",");
      }
      if (Array.isArray(this.info.attachmentUrl)) {
        this.info.attachmentUrl = this.info.attachmentUrl.map(item => item.url).join(",");
      }
      if (Array.isArray(this.info.drawingUrl)) {
        this.info.drawingUrl = this.info.drawingUrl.map(item => item.url).join(",");
      }

      this.$refs.infoForm.validate(valid => {
        if (valid) {
          const submitData = {
            ...this.info,
            list: this.selectedGoods
          };
          editMerchantOrder(submitData).then(res => {
            if (res.code === "200") {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success"
              });
              this.$router.go(-1);
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完整填写必填信息",
            type: "error"
          });
        }
      });
    }

  }
};
</script>
<style scoped>
.card {
  margin-bottom: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>